export default "__VITE_ASSET__DkLmY$0$__"